import { render, staticRenderFns } from "./ModalLogsSala.vue?vue&type=template&id=275c0c52&scoped=true"
import script from "./ModalLogsSala.vue?vue&type=script&lang=js"
export * from "./ModalLogsSala.vue?vue&type=script&lang=js"
import style0 from "./ModalLogsSala.css?vue&type=style&index=0&id=275c0c52&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275c0c52",
  null
  
)

export default component.exports